import { render, staticRenderFns } from "./editbillpriod.vue?vue&type=template&id=813296e8&"
import script from "./editbillpriod.vue?vue&type=script&lang=ts&"
export * from "./editbillpriod.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editbillpriod.vue"
export default component.exports